/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/~/lodash/_freeGlobal.js
 ** module id = 1315
 ** module chunks = 0
 **/